import usersModule from './users'
import newsModule from './news'
import votingModule from './voting'
import campaignsModule from './campaigns'
import eventsModule from './events'
import electionsModule from './elections'

export function initModules (axios, api) {
  return {
    users: usersModule(axios, api),
    news: newsModule(axios, api),
    voting: votingModule(axios, api),
    campaigns: campaignsModule(axios, api),
    events: eventsModule(axios, api),
    elections: electionsModule(axios, api)
  }
}
